import { useQuery } from '@tanstack/react-query'

import { getTruckModelsSelectQueryOptions } from '../query-options/get-truck-models-select-query-options'

/**
 * Select用の荷姿一覧のUseQuery
 */
export const useTruckModelsSelectQuery = (
  tenantKey: string,
  options?: {
    disabled?: boolean
    dcId?: number
    shippingDate?: string
  }
) => {
  const disabled = options?.disabled ?? false
  const dcId = options?.dcId
  const shippingDate = options?.shippingDate
  return useQuery({
    ...getTruckModelsSelectQueryOptions(tenantKey, dcId, shippingDate),
    enabled: !disabled,
    retry: false
  })
}
